(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseTarget(raw) {
    if (!raw) return null;
    var str = String(raw).trim();
    if (!str) return null;
    var date = new Date(str);
    if (isNaN(date.getTime())) {
      var normalized = str.replace(' ', 'T');
      date = new Date(normalized);
    }
    if (isNaN(date.getTime())) return null;
    return date.getTime();
  }

  function initCountdown(el) {
    if (!el || el.dataset.cdInit === 'true') return;
    var target = parseTarget(el.getAttribute('data-countdown-end'));
    if (target === null) return;

    el.dataset.cdInit = 'true';

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');

    function render() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (diff <= 0 && el._cdTimer) {
        clearInterval(el._cdTimer);
        el._cdTimer = null;
      }
    }

    render();
    el._cdTimer = setInterval(render, 1000);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.sbc-countdown');
    for (var i = 0; i < nodes.length; i++) {
      initCountdown(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event && event.target ? event.target : document);
  });
})();
